import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Section from '../components/Section';
import Card from '../components/Card';
import Button from '../components/Button';
import data from '../data/stdominicana-original';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './HomePage.scss';

const OurExperience = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out-cubic',
      offset: 100,
    });
  }, []);

  return (
    <div className="home-page">
      {/* Hero Section - Phase 2 ✅ */}
      <Hero
        title={data.ourExperience.title}
        subtitle={data.ourExperience.subtitle}
        description={data.ourExperience.description}
        backgroundImage={data.ourExperience.backgroundColor}
        minHeight="400px"
      />

      {/* Our Services Details Section */}
      <Section
        id="our-services-details"
        title={data.ourServicesDetails.title}
        subtitle={data.ourServicesDetails.subtitle}
        variant="default"
      >
        <div className="services-list-container">
          <ul className="services-bullet-list">
            {data.ourServicesDetails.items.map((item, index) => (
              <li
                key={index}
                className="service-item"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="service-content">
                  <span className="check-icon">✓</span>
                  <div className="service-text">
                    <strong>{item.title}:</strong> {item.description}
                  </div>
                </div>
              </li>
            ))}
          </ul>

          {data.ourServicesDetails.author && (
            <div className="author-info" data-aos="fade-up" data-aos-delay="500">
              <div className="author-image-container">
                <img
                  src={data.ourServicesDetails.author.image}
                  alt={data.ourServicesDetails.author.name}
                  className="author-image"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                <div className="author-placeholder" style={{ display: 'none' }}>
                  <span>LR</span>
                </div>
              </div>
              <div className="author-details">
                <p className="author-name">{data.ourServicesDetails.author.name}</p>
                <p className="author-position">{data.ourServicesDetails.author.position}</p>
              </div>
            </div>
          )}
        </div>

        <style jsx>{`
          .services-list-container {
            max-width: 900px;
            margin: 0 auto;
            padding: 0 1rem;
          }

          .services-bullet-list {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .service-item {
            margin-bottom: 1.5rem;
          }

          .service-content {
            display: flex;
            align-items: flex-start;
            gap: 1rem;
          }

          .check-icon {
            flex-shrink: 0;
            width: 32px;
            height: 32px;
            background-color: #f0854d;
            color: white;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 20px;
            font-weight: bold;
            margin-top: 2px;
          }

          .service-text {
            flex: 1;
            font-size: 18px;
            line-height: 1.6;
            color: var(--text-dark, #333);
          }

          .service-text strong {
            color: var(--primary, #1e40af);
          }

          .author-info {
            display: flex;
            align-items: center;
            gap: 1.5rem;
            margin-top: 3rem;
            padding: 1.5rem;
            background-color: rgba(0, 0, 0, 0.03);
            border-radius: 12px;
            border-left: 4px solid var(--primary, #1e40af);
          }

          .author-image-container {
            position: relative;
            flex-shrink: 0;
          }

          .author-image {
            width: 180px;
            height: 180px;
            border-radius: 50%;
            object-fit: cover;
            border: 3px solid var(--primary, #1e40af);
          }

          .author-placeholder {
            width: 180px;
            height: 180px;
            border-radius: 50%;
            background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 28px;
            font-weight: bold;
            border: 3px solid var(--primary, #1e40af);
          }

          .author-details {
            flex: 1;
          }

          .author-name {
            margin: 0 0 0.25rem 0;
            font-size: 1.125rem;
            font-weight: bold;
            color: var(--text-dark, #333);
          }

          .author-position {
            margin: 0;
            font-size: 1rem;
            font-style: italic;
            color: var(--text-muted, #666);
          }

          @media (max-width: 768px) {
            .service-content {
              gap: 0.75rem;
            }

            .check-icon {
              width: 28px;
              height: 28px;
              font-size: 18px;
            }

            .service-text {
              font-size: 16px;
            }

            .author-info {
              flex-direction: column;
              text-align: center;
              gap: 1rem;
            }

            .author-image,
            .author-placeholder {
              width: 70px;
              height: 70px;
            }

            .author-placeholder {
              font-size: 24px;
            }
          }
        `}</style>
      </Section>

      {/* Services Section - Phase 2 ✅ */}
      <Section
        id="services"
        title="Nuestras Soluciones"
        subtitle="Nuestra alta especialidad: aislamientos removibles o blankets que es el más idóneo en válvulas y equipos críticamente calientes que necesitan mantenimiento continuo en la industria, planta eléctrica, termoeléctrica y marina (barcos)."
        variant="primary"
      >
        <div className="services-grid">
          {data.ourExperience.items.map((item, index) => (
            <div
              key={index}
              data-aos="zoom-in"
              data-aos-delay={index * 100}
            >
              <Card
                title={item.title}
                description={item.description}
                icon={item.icon}
              />
            </div>
          ))}
        </div>
      </Section>

      {/* Features Section - Phase 2 ✅ */}
      {/* <Section
        id="features"
        title="¿Por qué elegirnos?"
        subtitle="Características que nos hacen únicos en la industria"
        variant="default"
      >
        <div className="features-grid">
          {data.features.map((feature, index) => (
            <Card
              key={index}
              icon={
                <span style={{ fontSize: '2rem' }}>
                  {index === 0 && '🏆'}
                  {index === 1 && '✓'}
                  {index === 2 && '⭐'}
                  {index === 3 && '🛠️'}
                </span>
              }
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </Section> */}

      {/* Testimonials Section - Phase 2 ✅ */}
      {/* <Section
        id="testimonials"
        title="Lo que dicen nuestros clientes"
        subtitle="Testimonios reales de empresas satisfechas"
        variant="gradient"
      >
        <div className="testimonials-grid">
          {data.testimonials.map((testimonial, index) => (
            <Card
              key={index}
              title={testimonial.name}
              description={
                <>
                  <p>"{testimonial.text}"</p>
                  <p style={{ marginTop: '1rem', fontWeight: 'bold' }}>
                    {testimonial.company}
                  </p>
                  <p style={{ fontSize: '0.9em', opacity: 0.8 }}>
                    {testimonial.position}
                  </p>
                </>
              }
              className="testimonial-card"
            />
          ))}
        </div>
      </Section> */}

      {/* <section id={data.companyInNumbers.sectionId} className="numbers-section">
        <div
          className="numbers-background"
          style={{ backgroundImage: `url(${data.companyInNumbers.backgroundImage})` }}
        >
          <div className="numbers-overlay"></div>
          <div className="container">
            <div className="numbers-content">
              <h2 className="numbers-title">{data.companyInNumbers.title}</h2>
              <div className="numbers-grid">
                {data.companyInNumbers.numbers.map((stat, index) => (
                  <div key={index} className="number-item">
                    <div className="number-value">{stat.number}</div>
                    <div className="number-label">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA Section - Phase 2 ✅ */}
      <Section
        id="cta"
        title={data.cta.title}
        subtitle={data.cta.subtitle}
        variant="dark"
      >
        <div style={{ textAlign: 'center' }} data-aos="zoom-in" data-aos-delay="200">
          <a
            href={data.cta.button.url}
            className="btn btn-secondary btn-lg cta-button"
            target="_blank"
            rel="noopener noreferrer"
            data-aos="zoom-in"
            data-aos-delay="300"
          >
            Solicita una Cotización
          </a>
        </div>
      </Section>

      {/* Component Test Section - For Development */}
      {/* <Section
        id="component-test"
        title="Component Test - Phase 1 & 2 Complete! ✅"
        subtitle="All components are working with the design system"
        variant="primary"
      >
        <div className="component-status">
          <div className="status-grid">
            <div className="status-item">
              <span className="status-icon">✅</span>
              <h3>Button</h3>
              <p>3 variants, 3 sizes</p>
            </div>
            <div className="status-item">
              <span className="status-icon">✅</span>
              <h3>Section</h3>
              <p>4 variants with overlay</p>
            </div>
            <div className="status-item">
              <span className="status-icon">✅</span>
              <h3>Card</h3>
              <p>Image & icon support</p>
            </div>
            <div className="status-item">
              <span className="status-icon">✅</span>
              <h3>Hero</h3>
              <p>Full-screen with CTA</p>
            </div>
          </div>

          <div style={{ marginTop: '2rem' }}>
            <Button variant="outline" size="medium" href="#about">
              Scroll to About Section
            </Button>
          </div>
        </div>
      </Section> */}
    </div>
  );
};

export default OurExperience;
